module.exports = function(posts) {
	'use strict'
  posts
  .controller('allpostsController', allpostsController)
	allpostsController.$inject = ["eventStream","$attrs","watchAllCheckboxesNgTable","removeFromOther","addToOther","warningAlertService","$timeout","config","$stateParams","$state","API_URL","deleteDataService","$http","cleanObj","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","reqursiveService","postDataService","alertService","putDataService","$interval","authtokenService","serverError","comunicateBetweenViews","checkArray","$window","offlineError"];
	
    function allpostsController(eventStream,$attrs,watchAllCheckboxesNgTable,removeFromOther,addToOther,warningAlertService,$timeout,config,$stateParams,$state,API_URL,deleteDataService,$http, cleanObj,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,postDataService,alertService, putDataService,$interval, authtokenService,serverError,comunicateBetweenViews,checkArray,$window, offlineError) {
      var vmap = this;
      $rootScope.emptyTable = false;
      vmap.editPostShow = false;
      // vmap.intervalHeartBeat = null;
      vmap.post_id = $stateParams.id;
      vmap.myPosts = $attrs.myPosts;
      vmap.config = config;
      var streamTaxonomy = 'posts';
      var appState = 'allposts'
      if(vmap.myPosts) {
        appState = 'myposts'
      }
      vmap.commentPostId = null; 
      var $data;
      if($stateParams.id) {
        vmap.editPostShow = true;
      } else {
        vmap.editPostShow = false;
      }
      var userId = authtokenService.getUserId();
      var state = 'posts';
      var category;
      var tag;
      var s;
      var page = 1;
      var author;
      var date_start;
      var date_end;
      var sortby ='date';
      var addtoTarget;
      var tagPosts = [];
      var commentsStatus;
      var postsStatus;
      vmap.statusTrash = false;
      vmap.selectedBulkAction = {value: 'default'};
      vmap.selectedAuthorFilter = {value: 'all'};
      vmap.postLocked = {};
      if(vmap.myPosts) {
        vmap.selectedAuthorFilter.value = userId.toString();
        author = userId
      }
      vmap.selectedCategory = {value: 'all'};
      if(comunicateBetweenViews.getCategory()) {
        category = comunicateBetweenViews.getCategory();
        vmap.selectedCategory= {value: category};
        comunicateBetweenViews.setCategory(null);
      }
      if(comunicateBetweenViews.getTag()) {
        tag = comunicateBetweenViews.getTag();
        comunicateBetweenViews.setTag(null);
      }
      if(comunicateBetweenViews.getAuthor()) {
        author = comunicateBetweenViews.getAuthor();
        comunicateBetweenViews.setAuthor(null);
        vmap.selectedAuthorFilter = {value: author.toString()};
      }
      vmap.status = "publish";
      var status = vmap.status;
      vmap.reverse = false;
      vmap.selectedTitle = -1;
      vmap.selectedAuthor = -1;
      vmap.selectedTags = -1;
      vmap.editCategoryShow = false;
      vmap.loadCategory = false;
      vmap.selectedBulkActionAuthor = {value: 'default'};
      vmap.selectedBulkActionComments = {value: 'default'};
      vmap.selectedBulkActionStatus = {value: 'default'};
      vmap.checkedPostsEdit = [];
      vmap.checkboxes = { 'checked': false, items: {} };
      vmap.hiddenBulkEdit = true;
      vmap.category = null;
      vmap.bulkTags = [];
      vmap.checkedPostsforUpdate = [];
      vmap.categorychecked = {item:{}};
      vmap.existTag = false;
      vmap.changeOrderFlag = false;
      vmap.numberOfItems;
      $scope.ranges = {
        'Today': [moment().startOf('day'), moment()],
        'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
        'Last 7 days': [moment().subtract('days', 7), moment()],
        'Last 30 days': [moment().subtract('days', 30), moment()],
        'This month': [moment().startOf('month'), moment().endOf('month')],
        'All days':[moment().subtract('year',5),moment()]
      };
      function heartbeatCallback(data) {
        $scope.$apply(function() {
          if(data.type=='post_locked') {
            vmap.postLocked[data.item_id] = {
              message: data.message
            };
            if(data.locked_by == parseInt(userId)) {
              vmap.postLocked[data.item_id].personal_message = data.personal_message;
            }
          } else if(data.type=='post_unlocked' && vmap.postLocked[data.item_id]) {
            delete vmap.postLocked[data.item_id];
          }
        });
      }
      $scope.addToExchange = function(typeExchange, postId) {
        $scope.typeAddToExchange = typeExchange;
        $scope.typeAddToExchangePostId = postId;
        $scope.addPostToExchangeModal = true;
      }
      $scope.closeAddPostToExchangeModal = function() {
        $scope.addPostToExchangeModal = false;
      }
      vmap.getApi = function(api) {
        vmap.api = api;
        vmap.status = undefined;
        vmap.tableParams.reload();
      }
      vmap.getFromApi = function(target,postId) {
        var ids = [];
        if(postId) {
          ids.push(postId);
        } else {
          ids = vmap.checkedPostsforUpdate
        }
        $rootScope.hasLoaded = false;
        var postFunction = function() {
          postDataService.save({
            param1:state, 
            param2: 'import', 
            param3:target
          },{
            ids:ids
          }).$promise.then(function(data){
            vmap.tableParams.reload();
            alertService('success','Success ', data.message, 2000);
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              $rootScope.hasLoaded = true;
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(error.status == 401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
              function(answer) {
                if(answer==200) {
                  postFunction();
                }
                // do something
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
              });
            }else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }
            $rootScope.hasLoaded = true;
          });
        }
        postFunction();
      }
      vmap.takeover = function(postId) {
        var takeoverMessage = (vmap.postLocked[postId].personal_message)? "This post is currently being edited in another session. If you take over, any unsaved changes there will be lost. Do you want to continue?" : 'Are you sure you want to take over this post?';
        warningAlertService('Post takeover',takeoverMessage, function cb() {
          var url = API_URL+ "posts/takeover"
          var updateDataPost = {
            post_id : postId
          }
          var updateFunction = function() {
            $http.put(url , updateDataPost)
            .success(function (data, stat, headers) {
              alertService('success','Success ', data.message, 2000);
              $rootScope.hasLoaded = false;
              $timeout(function() {
                vmap.editPost(postId);
              },0)
            })
            .error(function (data, status, header, config) {
              if(!window.navigator.onLine) {
                offlineError()
                $rootScope.hasLoaded = true;
                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                return
              }
              if(status ==401) {
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                  function(answer) {
                    if(answer==200) {   
                      updateFunction();
                    }
                  },
                  function(error) {
                  },
                  function(progress) {
                   // report progress
                });
              }else if(status ==502) {
                serverError()  
              } else { 
                alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
              }
              $rootScope.hasLoaded = true;
            }); 
          }
          updateFunction();
        })
      }
      var updateOrder = function(url,order) {
        var updateDataPost = {
          "order": parseInt(order)
        }
        var updateFunction = function() {
          $http.put(url , updateDataPost)
          .success(function (data, stat, headers) {
            $rootScope.hasLoaded = true;
            alertService('success','Success ', data.message, 2000);
          })
          .error(function (data, status, header, config) {
            if(!window.navigator.onLine) {
              offlineError()
              $rootScope.hasLoaded = true;
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    updateFunction();
                  }
                },
                function(error) {
                },
                function(progress) {
                 // report progress
              });
            }else if(status ==502) {
              serverError()  
            } else { 
              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
            }
            $rootScope.hasLoaded = true;
          }); 
        }
        updateFunction();
      }
      vmap.changeOrder = function() {
        vmap.changeOrderFlag = true;
      }
      vmap.outOrderFocus = function(postId,order) {
        if(vmap.changeOrderFlag) {
          $rootScope.hasLoaded = false;
          vmap.changeOrderFlag = false;
          updateOrder(API_URL+ "posts/order/"+postId,order);
        }
      }
      vmap.updateOrder = function(postId,order) {
        updateOrder(API_URL+ "posts/"+postId,order);
      }
      vmap.permisions = true;
      if($rootScope.role_id == 'author-junior') {
        vmap.permisions = false;
      }
      vmap.superPermisions = false;
      if($rootScope.role_id == 'administrator' || $rootScope.role_id == 'superadmin') {
        vmap.superPermisions = true;
      }
      vmap.takeoverPermisions = false;
      if($rootScope.role_id == 'administrator' || $rootScope.role_id == 'superadmin' || $rootScope.role_id == 'editor' ) {
        vmap.takeoverPermisions = true;
      }
      vmap.previewPost = function(post) {
        if(post.status!='publish') {
          $window.open(post.preview+ '&ts=' + Date.now(), '_preview');
        } else {
          $window.open(post.url, '_view');
        }
      }
      var addNewTagFunction = function(data) {
        vmap.newTagRequired = false;
        if(!checkArray.contains.call(vmap.bulkTags,data.tagId)) {
          vmap.bulkTags.push(data.tagId);
          vmap.searchtagfocus = null;
          vmap.existTag = false;
        } else {
          vmap.existTag = true;
        }
      }
      $scope.$on('select-tag', function(event,data) {
        addNewTagFunction(data.selectedTagObj)
      });
      vmap.addNewTag = function() {
        if(vmap.searchtagfocus && vmap.searchtagfocus.length>2) {
          var postFunction = function() {
            postDataService.save({
              param1:'tags', 
              // param2: 'create'
            },{
              'name': vmap.searchtagfocus
            }).$promise.then(function(postTag){
            var data = {
              tagId:postTag.tag._id,
              tagname: postTag.tag.name
            } 
              addNewTagFunction(data);
            }, function(error){
              if(!window.navigator.onLine) {
                offlineError()
                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                return
              }
              if(error.status ==401) {
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                  function(answer) {
                    if(answer==200) {   
                      postFunction();
                    }
                  },
                  function(error) {
                  },
                  function(progress) {
                   // report progress
                });
              } else if(error.status ==502) {
                serverError()
              } else if(error.status ==400) {
                var data = {
                  tagId:error.data.tag._id,
                  tagname: error.data.tag.name
                } 
                addNewTagFunction(data);
              }
            });
          }
          postFunction();
        } else {
          vmap.newTagRequired = true;
        }
      }
      vmap.removeFromTagsList = function(index) {
        vmap.bulkTags.splice(index, 1);
      }
      var arrayPostsIdFunction = function() {
        if (vmap.checkedPostsEdit.length>0 ) {
          for(var i=0;i<vmap.checkedPostsEdit.length;i++) {
            vmap.checkedPostsforUpdate.push(vmap.checkedPostsEdit[i]._id);
          }
        }
      }
      var putPostsFunction = function(url, status) {
        if(vmap.checkedPostsforUpdate.length == 0) return;
        if(vmap.bulkTags.length > 0) {
          tagPosts = vmap.bulkTags;
        } else {
          tagPosts = null;
        }
        if(vmap.selectedBulkActionComments.value == 'default') {
          commentsStatus = null;
        } else if (vmap.selectedBulkActionComments.value == "allow"){
          commentsStatus = "open";
        } else {                   
          commentsStatus = "closed";
        }
        if(status != 'no-trash') {
          postsStatus = status;
        } else { 
          if(vmap.selectedBulkActionStatus.value == 'default') {
            postsStatus = null;
          } else {
            postsStatus = vmap.selectedBulkActionStatus.value;
          }
          if(vmap.editPostsTag) {
            if(vmap.editPostsTag.length==0) {
              tagPosts = null;
            }else {
              tagPosts = vmap.editPostsTag;
            }
          }
        }
        var updateDataPosts = {
          "ids": vmap.checkedPostsforUpdate,
          "category": vmap.category,
          "tags": tagPosts,
          "status": postsStatus,
          "comment_status": commentsStatus,
        }
        cleanObj.clean(updateDataPosts);
        var putFunction = function() {
          $http.put(url , updateDataPosts)
          .success(function (data, status, headers) {
              alertService('success','Success ', data.message, 2000);
              vmap.cancelBulkEdit();
              vmap.tableParams.reload();
          })
          .error(function (data, status, header, config) {
            if(!window.navigator.onLine) {
              offlineError()
              $rootScope.hasLoaded = true;
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {   
                  if(answer==200) {
                    putFunction();
                  }
                },
                function(error) {
                },
                function(progress) {
                 // report progress
              });
            }else if(status ==502) {
              serverError();
            } else {  
              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
              vmap.cancelBulkEdit();
              $rootScope.hasLoaded = true; 
            }
          });
        }
        putFunction();
      }
      vmap.updateStatusPost = function(post_id, status) {
        vmap.checkedPostsforUpdate = [];
        vmap.checkedPostsforUpdate.push(post_id);
        putPostsFunction(API_URL + 'posts', status);
      }
      vmap.updateBulkAction = function() {
        arrayPostsIdFunction();
        putPostsFunction(API_URL + 'posts', 'no-trash');
        $rootScope.hasLoaded = false;
      }
      vmap.removeFromOther = removeFromOther
      vmap.addToOther = addToOther
      vmap.editPost = function(postId) {    
        vmap.editPostShow = true;
        vmap.postLocked = {};
        if(eventStream.hasMessageHandler(streamTaxonomy,heartbeatCallback)) {
          eventStream.offMessage(streamTaxonomy,heartbeatCallback);
        }
        jQuery("html, body").animate({
          scrollTop: 0
        }, 600);
        vmap.post_id = postId;
        $state.transitionTo('app.'+ appState, {id: vmap.post_id}, {
            location: true,
            inherit: true,
            relative: $state.$current,
            notify: false
        });
      }
      var html = angular.element( document.querySelector('html'));
      // vmap.editCategory = function(categoryId) { 
        
      //   html.addClass('overflow-hidden');
      //   vmap.editCategoryShow = !vmap.editCategoryShow;
      //   vmap.categorySelected = categoryId;
      //   $scope.$broadcast("editCategory", {categorybroadcast:vmap.categorySelected});
      //   setTimeout(function () {
      //   if(categoryId) {
      //     var topPos = jQuery(".checked")[0].offsetTop;

      //       jQuery('#modalCategoryEdit').animate({scrollTop: topPos-60},600);
      //     } else {
      //       jQuery('#modalCategoryEdit').animate({scrollTop: 0},600);
      //     }
      //   },100);
      // }
      vmap.updateSelection = function(category_id, checked,categoryObj,event) {
        if(categoryObj.children && categoryObj.children.length) {
          event.preventDefault();
          return
        };
        var updateSelectionTree = function(categories) {
          if(checked) {
            for (var i=0; i<categories.length; i++){
              if (categories[i]._id !== category_id) {
                vmap.categorychecked.item[categories[i]._id] = false;
              }
            }
            vmap.category = category_id;
          } else {
            vmap.category = null;
          }
        }
        updateSelectionTree(vmap.categoriesTreeInput);  
      }
      vmap.searchComment = function(post) {
        vmap.commentPostId =  post._id;        
        vmap.serchCommentsModalShow = true;
        $rootScope.modalShow = true;
      } 
      vmap.closeSearchComment = function() {
        vmap.serchCommentsModalShow = false;
        $rootScope.modalShow = false;
        vmap.commentPostId = null;
      }
      vmap.cancelCategoryModal =function() {
        html.removeClass('overflow-hidden');
        vmap.editCategoryShow= false;
        $scope.$broadcast("CategorCheckAll", {check:false});
      }
      vmap.editAuthor = function(index) {
        vmap.selectedAuthor = index;
      }
      vmap.cancelEditAuthor = function() {
        vmap.selectedAuthor = -1;
      }
      vmap.editTitle = function(index) {
        vmap.selectedTitle = index;
      }
      vmap.cancelEditTitle = function() {
        vmap.selectedTitle = -1;
      }
      vmap.editTags = function(index) {
        vmap.selectedTags = index;
      }
      vmap.cancelEditTags = function() {
        vmap.selectedTags = -1;
      }
      vmap.deletePostsFunction = function() {
        postDataService.save({
          param1:state,
          param2:'bulk',
          param3:'delete' 
        },{
          'ids':vmap.checkedPostsforUpdate
        }).$promise.then(function(postData){
          alertService('success','Success ', postData.message, 2000);
          vmap.cancelBulkEdit();
          vmap.tableParams.reload();
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) { 
                  if(answer==200) {
                    vmap.deletePostsFunction();
                  }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }else if(error.status ==502) {
            serverError();
          }else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          vmap.cancelBulkEdit();
        });
      }
      vmap.deletePosts = function(post_id) {
        vmap.checkedPostsforUpdate = [];
        vmap.checkedPostsforUpdate.push(post_id)
        vmap.deletePostsFunction();  
      }
      vmap.bulkAction = function(param) {
        if(param == "edit" && vmap.checkedPostsEdit.length > 0) {
          vmap.hiddenBulkEdit =false;
        }else if(param == "trash" && vmap.checkedPostsEdit.length > 0){
          vmap.checkedPostsforUpdate = [];
          arrayPostsIdFunction();
          putPostsFunction(API_URL + 'posts', 'trash');
        } else if (param == 'delete' && vmap.checkedPostsEdit.length>0 ) {
          vmap.checkedPostsforUpdate = [];
          vmap.hiddenBulkEdit =true;
          $rootScope.hasLoaded = false;
          arrayPostsIdFunction();
          vmap.deletePostsFunction();
        } else if(param=='deskplus' && vmap.checkedPostsEdit.length>0){
          vmap.checkedPostsforUpdate = [];
          arrayPostsIdFunction();
          vmap.getFromApi('deskplus');
        } 
      }
      watchAllCheckboxesNgTable.watch($scope,vmap,true)
      vmap.checkedPost = function(checked, post) {
        if (checked) {
          vmap.checkedPostsEdit.push(post);
        } else {
         vmap.checkedPostsEdit = vmap.checkedPostsEdit.filter(function( obj ) {
              return obj._id !== post._id;
          });
        }
        
      }
      vmap.removeEditPost = function(post_id) {
        vmap.checkedPostsEdit = vmap.checkedPostsEdit.filter(function( obj ) {
              return obj._id !== post_id;
        });
        vmap.checkboxes.items[post_id] = false;
        if(!vmap.checkedPostsEdit.length > 0) {
          vmap.cancelBulkEdit();
        }
      }
      vmap.cancelBulkEdit =function() {
        if(!vmap.hiddenBulkEdit) {
          var updateSelectionTree = function(categories) {
            for (var i=0; i<categories.length; i++){
              vmap.categorychecked.item[categories[i]._id] = false;
            }
          }
          updateSelectionTree(vmap.categoriesTreeInput);
        }
        vmap.category = null;
        vmap.hiddenBulkEdit = true;
        watchAllCheckboxesNgTable.resetCheckBox(vmap)
        vmap.checkedPostsforUpdate = [];
        vmap.selectedBulkActionStatus={value:'default'};
        vmap.selectedBulkActionComments ={value:'default'};
        vmap.selectedBulkAction = {value: 'default'};
        vmap.bulkTags = [];
      }
      vmap.categoryTreeFunction= function() {
        vmap.categoriesTreeInput = reqursiveService.getReqursiveArray(vmap.categories);
        vmap.categoriesTreeSelect = angular.copy(vmap.categoriesTreeInput);
        for(var i=0; i< vmap.categoriesTreeSelect.length; i++) {
          var n = (vmap.categoriesTreeSelect[i].ancestors.length)*2;
          var empty = "\u00A0";
          for(var j=0;j<n;j++) {
            vmap.categoriesTreeSelect[i].name = empty+vmap.categoriesTreeSelect[i].name;
          }
        }
      }
      var getCategoriesFunction = function() {
        getDataService.get({param1:'categories', param2: null, tree:1}).$promise.then(function(data){      
          vmap.loadCategory= true;
          vmap.categories = data.categories;
          vmap.categoryTreeFunction();
          
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {
                    getCategoriesFunction();
                  }
                },
                function(error) {
                  // report something
                },
                function(progress) {
                 // report progress
                });
          } else if(error.status ==502) {
            serverError()
          }
        });
      }
      var getAuthorsFunction = function() {
        getDataService.get({param1:'users', param2: 'all'}).$promise.then(function(data){      
          vmap.authorList = data.users;
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {
                    getAuthorsFunction();
                  }
                },
                function(error) {
                  // report something
                },
                function(progress) {
                // report progress
                });
          } else if(error.status ==502) {
            serverError()
          }else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
        });
      }
      getAuthorsFunction();
      // var setLockedPostFunction = function() {
        // vmap.postLocked = {};
        // if(vmap.dataGet && vmap.dataGet.length>0) {
        //   for(var i=0; i<vmap.dataGet.length;i++) {
        //     vmap.postLocked[vmap.dataGet[i]._id] = false;

        //   }
        //   for(var i=0; i<vmap.lockedPosts.length;i++) {
        //     if(userId !=vmap.lockedPosts[i].edit_last) {
        //       vmap.postLocked[vmap.lockedPosts[i]._id] = {messagevmap.lockedPosts[i].message};
        //     }
        //   }
        // }
      // }

      // vmap.intervalHeartBeatFunction = function() {
      //   if(!$state.is('app.' + appState) && vmap) return;   
      //   var HeartBeatArray = [];
      //   for(var i=0; i<vmap.dataGet.length;i++) {
      //     HeartBeatArray.push(vmap.dataGet[i]._id);
      //   }
      //   var intervalFunction = function() { 
      //     postDataService.save({
      //       param1:state, 
      //       param2: 'heartbeat'
      //     },{
      //       "ids": HeartBeatArray
      //     }).$promise.then(function(data){
      //       vmap.lockedPosts = data.result;
      //       setLockedPostFunction();
          
      //     }, function(error){
      //       if(!window.navigator.onLine) {
      //         offlineError(vmap.intervalHeartBeatFunction)
      //         return
      //       }
      //       if(error.status == 401) {
      //         var promise = refreshtokenService.getAccessToken();
      //         promise.then(
      //         function(answer) {
      //           if(answer==200) {
      //             intervalFunction();                      
      //           }
      //         },
      //         function(error) {
      //           // report something
      //         },
      //         function(progress) {
      //           // report progress
      //         });
      //       }
      //     });
      //   }
      //   intervalFunction();
      // }
      vmap.changeSearch = function(search_data) {
        if(search_data) {
          s = search_data;
        } else {
          s = null;
          $timeout(function() {
            vmap.search();
          },0)            
        }
      }
      vmap.switchCategories = function(item) {
          category = item;
          if (item=='all') {
            category = null;
          }
      }
      vmap.switchAuthorFilter = function(item) {
          author = item;
          if (item=='all') {
              author = null;
          }
      }
      vmap.changeDate = function(value) {
        vmap.dateRangevalue = value;
        if(vmap.dateRangevalue) {
          if(value.startDate && value.endDate) {
            date_start = value.startDate.format('YYYY-MM-DD');
            date_end = value.endDate.format('YYYY-MM-DD');
          } else {
            date_start = null;
            date_end = null;
          }
        } else {
            date_start = null;
            date_end = null;
        }
      }
      function reloadTableFunction() {
        if(vmap.tableParams.page() ==1) {
          vmap.tableParams.reload();
        } else {
          vmap.tableParams.page(1);
        }
      } 
      vmap.postFilter = function() {
        reloadTableFunction();
      }
      vmap.resetAllFilters = function() {
        vmap.status = 'publish';
        status = vmap.status;
        vmap.selectedCategory = {value: 'all'};
        vmap.selectedAuthorFilter = {value: 'all'};
        author = null;
        if(vmap.myPosts) {
          vmap.selectedAuthorFilter.value = userId.toString();
          author = userId;
        }
        vmap.searchData = null;
        tag = null;
        s = null;
        category = null;
        date_start = null;
        date_end = null;
        $scope.$broadcast('clear-daterange',true);
        reloadTableFunction();
      }
      vmap.authorPosts = function(value) {
        author = value;
        vmap.selectedAuthorFilter = {value: value.toString()};
        reloadTableFunction();
      }
      vmap.categoryPosts = function(value) {
        category = value;
        reloadTableFunction();
      }
      vmap.tagPosts =function(value) {
        tag = value;
        reloadTableFunction();
      } 
      vmap.changeStatus =function(event,activeStatus) {
        vmap.status = activeStatus;
        vmap.api = undefined;
        if(activeStatus == 'all') {
          status = null;
        } else {
          status = activeStatus;
        }
        if(activeStatus == 'trash') {
          vmap.statusTrash = true;
        } else {
          vmap.statusTrash = false;
        }
        reloadTableFunction();
      }
      vmap.search =function(value) {
        if(value) {
          s = value.toLowerCase();
        } else {
          s = null;
        }
        reloadTableFunction();
      }
      vmap.tableReloadFunction = function(page) {
        vmap.tableParams = new NgTableParams({
            page: page || 1,
            count: 20,
        }, {
        getData: function(params) {
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: null,
            category: (!vmap.api)? category:undefined,
            tag:(!vmap.api)? tag:undefined,
            s:(!vmap.api)? s:undefined,
            status: (!vmap.api)? status:undefined,
            page: params.page(),
            limit: params.count(),
            author:(!vmap.api)? author:undefined,
            sortby:(!vmap.api)? $rootScope.sortby:undefined, 
            sort : (!vmap.api)? $rootScope.sort:undefined,
            date_start: (!vmap.api)? date_start:undefined,
            date_end: (!vmap.api)? date_end:undefined,
            api: vmap.api
            }).$promise.then(function(data){
            
            $rootScope.emptyTable = false;
            $rootScope.hasLoaded = true;
            $data = data.posts;
            for (var i=0; i<$data.length;i++) {
              $data[i].tags = checkArray.removeDuplicate($data[i].tags);
              if($data[i].lock && Object.keys($data[i].lock).length > 0) {
                vmap.postLocked[$data[i]._id] = {
                  message: $data[i].lock.message
                };
                if($data[i].lock.locked_by && $data[i].lock.locked_by._id == parseInt(userId)) {
                  vmap.postLocked[$data[i]._id].personal_message = $data[i].lock.personal_message;
                }
              }
            }
            vmap.dataGet = data.posts;
            watchAllCheckboxesNgTable.resetCheckBox(vmap)
            if ( angular.element('#quick-edit').length >0) {
                angular.element('#quick-edit').remove();
            }
            vmap.cancelBulkEdit();
            params.total(data.count);
            params.numPages(data.max_pages);
            jQuery('.goTo input').val("");
            if(!eventStream.getConnection(streamTaxonomy)) {
              eventStream.connect(streamTaxonomy,vmap.config.lockingManager[streamTaxonomy]);
            }
            if(!eventStream.hasMessageHandler(streamTaxonomy,heartbeatCallback)) {
              eventStream.onMessage(streamTaxonomy,heartbeatCallback);
            }
            // if(vmap.intervalHeartBeat) {
            //   $interval.cancel(vmap.intervalHeartBeat);
            //   vmap.intervalHeartBeat = null;
            // }
            // if( typeof(vmap.intervalHeartBeatFunction) === 'function' && !vmap.api) {
            //   vmap.intervalHeartBeat = $interval(vmap.intervalHeartBeatFunction,config.heartbeat.pulse*1000);
            //   vmap.intervalHeartBeatFunction();
            // }
            vmap.selectedBulkAction = {value: 'default'};
            if(!vmap.api) {
              getCategoriesFunction();
            }
            vmap.numberOfItems = data.count;
            if(category) {
              vmap.selectedCategory= {value: category};
            }
            if(author) {
              vmap.selectedAuthorFilter = {value: author.toString()};
            }
            return $data;
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError('refresh')
              $rootScope.hasLoaded = true;
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {
                    vmap.tableReloadFunction(params.page());
                  }
                },
                function(error) {
                },
                function(progress) {
                  // report progress
              });
            } else if(error.status ==404) {
              $rootScope.emptyTable = true;
              vmap.numberOfItems = 0;
              vmap.cancelBulkEdit();
              if ( angular.element('#quick-edit').length >0) {
                angular.element('#quick-edit').remove();
              }
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }
            $rootScope.hasLoaded = true;
          });
        }    
      });
    }
    vmap.tableReloadFunction();   
    $scope.$on('$destroy', function() {
      eventStream.disconnect(streamTaxonomy);
      $rootScope.eventStreamError = false;
      // if(vmap.intervalHeartBeat) {
      //   $interval.cancel(vmap.intervalHeartBeat);
      // }
      // vmap.intervalHeartBeat = null;
      // vmap.intervalHeartBeatFunction = null;
    });
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/allposts/js/allpostsController.js
// module id = 548
// module chunks = 0